import React from 'react'

import {Navigator} from '@progyny/components/Navigator'
import {CreateAccountMutationVariables} from '@progyny/generated/graphql'

export type CreateAccountSubProps = {
  navigator: typeof Navigator
  callback: () => void
  initialValue: CreateAccountMutationVariables
  updateLoading: boolean
  persistMemberData: (
    variables: CreateAccountMutationVariables
  ) => void | Promise<void>
  goBack: () => void
}

export type CreateAccountSubRoute = {
  path: string
  component: React.ComponentType<CreateAccountSubProps>
  headerTitle?: string
  description?: string
  showProgressBar?: boolean
  exact?: boolean
  progressBarTitle?: string
}

export enum CreateAccountRoutes {
  CONSENT,
  BIRTH_DATE,
  CITY,
  PREFERENCES,
  COMPLETE,
}
